export const getCoachDetails = (data) => {
	const {
		coach_details: {
			call_time,
			completed_calls,
			meeting_id,
			total_calls,
			call_status,
			cert_url,
			score,
		},
		calendly_url,
	} = data;
	return {
		call_time,
		completed_calls,
		meeting_id,
		total_calls,
		calendly_url,
		call_status,
		cert_url_speech: cert_url,
		score_speech: score,
	};
};
